export default __webpack_public_path__ + "static/stock-building-e0a18a33b229cee7ea1bcd09cf79fbc7.jpg";